import { 
  Component,
  Input,
  OnInit,
} from '@angular/core'; 
import { VhQueryAutoWeb, VhImage, VhEventMediator } from 'vhautowebdb';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FunctionService  } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';
import { AtwUpdateDbComponent } from 'vhobjects-service';

// import { IconsComponent } from '../../../../icons/icons.component';

@Component({
  selector: 'atw-animate-button-admin-config',
  templateUrl: './animate-button-admin-config.component.html',
  styleUrls: ['./animate-button-admin-config.component.scss']
})
export class AtwAnimateButtonAdminConfig  extends AtwUpdateDbComponent implements OnInit {
isCollapsed: boolean = false;
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  currentViewAll: any = {};
  dataAfterChange: any = {} // lưu tên và style data để cập nhật vào database.
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  fieldSettingEffect: string = '';
  id_subproject: any;
  arr_link_page: any;
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  style_color: string = '' // biến này lấy giá trị của màu rgb và alpha;
  isOpenOptionsBorder: boolean = false;
  blockList: any = [];
  blockTemp: any = [];
  configMode: 'basic' | 'advanced' = 'basic';
  isImageSaved: boolean = true;
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    private vhImage: VhImage,
    private nzMessageService: NzMessageService,
    public functionService: FunctionService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService); 
  }
  ngOnInit(): void {
    this.getBlock();
  }
  getBlock() {
    this.vhQueryAutoWeb.getBlocks_byFields({ type: 'hover_blank' })
      .then((pages) => {
        //
        this.blockTemp = pages
        this.blockTemp.forEach((page) => {
          if (page.type === "hover_blank") {
            this.blockList.push(page)
          }
        });
      })
  }
  handleChangeDirection(value) {
    // this.class['animate-button__point--popup'] = {}
    // this.class['animate-button__point--popup']['position'] = 'absolute'
    if (value === 'left') {
      this.class['animate-button__point--popup']['right'] = '100%'
      this.class['animate-button__point--popup']['left'] = 'unset'
      this.class['animate-button__point--popup']['bottom'] = 'unset'
      this.class['animate-button__point--popup']['top'] = 'unset'
    }
    if (value === 'top') {
      this.class['animate-button__point--popup']['top'] = '0'
      this.class['animate-button__point--popup']['bottom'] = 'unset'
      this.class['animate-button__point--popup']['left'] = 'unset'
      this.class['animate-button__point--popup']['right'] = 'unset'

    }
    if (value === 'bottom') {
      this.class['animate-button__point--popup']['bottom'] = '0'
      this.class['animate-button__point--popup']['left'] = 'unset'
      this.class['animate-button__point--popup']['top'] = 'unset'
      this.class['animate-button__point--popup']['right'] = 'unset'
    }
    if (value === 'right') {
      this.class['animate-button__point--popup']['left'] = '100%'
      this.class['animate-button__point--popup']['bottom'] = 'unset'
      this.class['animate-button__point--popup']['top'] = 'unset'
      this.class['animate-button__point--popup']['right'] = 'unset'

    }
  }

  saveImage() {
    // this.vhComponent.showToast(2000, "Lưu ảnh thành công", "success-toast");
    this.nzMessageService.success("Lưu ảnh thành công")
    // this.updateCss('data', this.data_tool['data']);
    this.isImageSaved = true;
  }
  // updateObject() {

  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {

  //     })
  // }
  onUpload(e) {
    const file = e.target.files[0];
    if (file) {
      this.vhImage.getImageFromDesktop(file, "images/design/objects", this.staticdata.img || null, 2000000).then(
        (rsp: any) => {

          if (rsp.vcode === 0) {
            this.staticdata.data.img = rsp.data;
            this.saveImage();
            this.functionService.createMessage(
              'success',
              'Hình ảnh đã được tải thành công !!!'
            );
          } else {
            this.functionService.createMessage(
              'error',
              `Tải ảnh thất bại! Lý do: ${rsp.message}`
            );
          }

        },
        (error) => {

          // this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
        }
      );
    }
    this.isImageSaved = true; 1

  }

  /** UPLOAD IMAGE */
  openUpload() {
    if (isPlatformBrowser(this.platformId)) {
      var inputVal = document.querySelector('#upload') as HTMLElement;
      inputVal.click();
    }
  }


  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }
  /**
   * update trường mobile_portrait_hidden or desktop_hidden cho object
   * @param value 
   */
  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại. 
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
}
